import React, { Component } from 'react';
import style from './leftbar.less';
import iconsStyle from '../../styles/icons.less';
import className from 'classnames';
import { setActivePage, setFieldValue } from '../../app.reducer.jsx';
import { bindActionCreators } from '../../app.store.jsx';
import _ from '../../i18n.jsx';
import { animateScrollToPage } from '../../questionnaire.utils.jsx';

export default class LeftBar extends Component {
    render() {
        const { pageList, lastPageIndex, navigationPageList, currentPageIndex, headerLink, fields, staticLeftBar } = this.props;
        let pageIndex, isActive;
        if (!staticLeftBar && 0 < navigationPageList.length) {
            const currentPageId = pageList[currentPageIndex].id;
            pageIndex = navigationPageList.findIndex(({ id }) => id === currentPageId);
            isActive = pageIndex === lastPageIndex;
        }
        const props = { currentPageIndex, pageList, lastPageIndex, navigationPageList, isActive, fields, staticLeftBar };
        return (
            <nav tabIndex="-1" className={style.leftBar}>
                <a href={headerLink} className={style.leftBarHeader__brand}>
                    <span className={style.leftBarHeader__icon}></span>
                </a>
                <span className={style.leftBarHeader__title}>{_('Family Health History')}</span>
                <Navigation {...props}/>
            </nav>
        );
    }
}

export class LeftBarNavigationTitle extends Component {
    constructor() {
        super();
        this.navigate = this.navigate.bind(this);
        this._setActivePage = bindActionCreators(setActivePage);
        this._setFieldValue = bindActionCreators(setFieldValue);
    }
    navigate() {
        const { navigateTo, lastPageIndex, pageListSize, finished } = this.props;
        if (navigateTo < pageListSize && navigateTo <= lastPageIndex) {
            if (!finished) {
                this._setFieldValue('currentPageIndex', navigateTo, 'pages');
                this._setActivePage(navigateTo);
            }
            animateScrollToPage(navigateTo, finished);
        }
    }
    render() {
        const { iconName, isActive, isPassed, hidden, staticLeftBar } = this.props;
        const titleIconClassName = className(iconsStyle[`icon-${iconName}`], style.leftBarNavigation__icon, { [style.disabled]: !isActive }, { [style.passed]: !isActive && isPassed });
        const titleClassName = className(style.leftBarNavigation__title, { [style.disabled]: staticLeftBar }, { [style.hidden]: hidden }, { [style.active]: isActive });
        return (
            <li className={titleClassName} onClick={this.navigate}>
                <span className={titleIconClassName}></span>
                <a className={style.leftBarNavigation__text} tabIndex="-1">{this.props.text}</a>
            </li>
        );
    }
}

export class LeftBarNavigationItem extends Component {
    constructor() {
        super();
        this.navigate = this.navigate.bind(this);
        this._setActivePage = bindActionCreators(setActivePage);
        this._setFieldValue = bindActionCreators(setFieldValue);
    }
    navigate() {
        const { navigateTo, lastPageIndex, pageListSize, finished } = this.props;
        if (navigateTo < pageListSize && navigateTo <= lastPageIndex) {
            if (!finished) {
                this._setFieldValue('currentPageIndex', navigateTo, 'pages');
                this._setActivePage(navigateTo);
            }
            animateScrollToPage(navigateTo, finished);
        }
    }
    render() {
        const { iconName, isActive, isPassed, hidden, staticLeftBar } = this.props;
        const itemIconClassName = className(iconsStyle[`icon-${iconName}`], style.leftBarNavigation__icon, { [style.active]: isActive }, { [style.passed]: isPassed });
        const itemClassName = className(style.leftBarNavigation__item, { [style.disabled]: staticLeftBar }, { [style.hidden]: hidden }, { [style.active]: isActive });
        return (
            <li className={itemClassName} onClick={this.navigate}>
                <span className={itemIconClassName}></span>
                <a className={style.leftBarNavigation__text} tabIndex="-1">{this.props.text}</a>
            </li>
        );
    }
}

export class Navigation extends Component {
    constructor() {
        super();
        this.getNavigationList = this.getNavigationList.bind(this);
    }
    getNavigationList() {
        const { pageList, navigationPageList, currentPageIndex, lastPageIndex, fields, staticLeftBar } = this.props;
        let isActiveTitle, isPassed, isActiveItem,
            hidden = false;
        const linkId = 'welcome-page';
        const navigationList = navigationPageList.map((page, index) => {
            const { id: pageId, group: pageGroup } = page;
            if (pageId !== linkId) {
                const isTitleElement = page.group && page.header;
                let pageIndexByGroup, pageIndexById, pageListSize, pageIndex;
                if (!staticLeftBar) {
                    const { id: currentPageId, group: currentPageGroup } = pageList[currentPageIndex];
                    pageIndexByGroup = pageList.findIndex(({ group }) => group === pageGroup);
                    pageIndexById = pageList.findIndex(({ id }) => id === pageId);
                    isActiveTitle = pageGroup === currentPageGroup;
                    isActiveItem = pageId === currentPageId;
                    pageIndex = 0 > pageIndexById ? pageIndexByGroup : pageIndexById;
                    isPassed = pageIndex <= lastPageIndex;
                    pageListSize = pageList.length;
                }
                let iconName;
                if (isTitleElement) {
                    iconName = Navigation.ICONS[page.id];
                } else if (pageIndex < lastPageIndex) {
                    iconName = Navigation.ICONS.CHECKMARK;
                }
                const itemText = isTitleElement ? page.group : page.title;
                const isActive = isTitleElement ? isActiveTitle : isActiveItem;
                const LeftBarNavElement = isTitleElement ? LeftBarNavigationTitle : LeftBarNavigationItem;
                const nextPage = navigationPageList[index + 1];
                const nextPageCondition = nextPage ? nextPage.condition : false;
                const fieldValues = fields ? fields.toJS() : null;
                if (!staticLeftBar && nextPageCondition && !nextPageCondition(fieldValues)) {
                    pageIndex++;
                }
                if (!staticLeftBar && page.condition && !page.condition(fieldValues)) {
                    hidden = true;
                    pageIndex++;
                } else {
                    hidden = false;
                }
                const finished = staticLeftBar ? false : fieldValues.finished || false;
                const props = {
                    finished,
                    hidden,
                    pageListSize,
                    isPassed,
                    lastPageIndex,
                    isActive,
                    navigateTo: pageIndex,
                    iconName,
                    text: itemText,
                    staticLeftBar
                };
                return <LeftBarNavElement {...props} key={page.id} />;
            }
        });
        return navigationList;
    }
    render() {
        const navigationList = this.getNavigationList();
        return (
            <ul className={style.leftBarNavigation__list}>
                { navigationList }
            </ul>
        );
    }
}

Navigation.ICONS = {
    'personal-information': 'personal',
    'health-information': 'health',
    'family-tree': 'family',
    comments: 'comments',
    'final-step': 'action-send',
    'finish-page': 'results',
    CHECKMARK: 'list-checkmark'
};
